'use client';
import type { EnvironmentOperation } from '../../../src/shared/wireContract';
import { useEnvironmentOperation } from '../../lib/useEnvironmentOperation';
import { apiErrorMessage, elowenClient } from '../../lib/elowenClient';
import { OperationProgressDialog } from './OperationProgressDialog';
import { useToast } from './Toast';

export function EnvironmentDockProgressDialog({ operation, title, onClose, onClosed, successDelayMs, onAccepted, onAcknowledge }: {
  operation: EnvironmentOperation; title: string; onClose: () => void; onClosed: () => void; successDelayMs: number;
  onAccepted: (id: string) => void; onAcknowledge: () => Promise<void>;
}) {
  const followed = useEnvironmentOperation(operation.id);
  const { toast } = useToast();
  const retry = () => {
    void elowenClient.environmentAction(operation.projectId, operation.action, operation.generation)
      .then(next => {
        void onAcknowledge().catch(error => toast(apiErrorMessage(error), 'error', { error }));
        onAccepted(next.id);
      }).catch(error => toast(apiErrorMessage(error), 'error', { error }));
  };
  return <OperationProgressDialog title={title} operation={operation} logTail={followed.logTail}
    loadError={followed.loadError} onRetry={retry} successDelayMs={successDelayMs} onClose={onClose} onClosed={onClosed} />;
}
